export type LegalDocumentCode =
  'privacy_notice' | 'terms_of_service' | 'data_processing_agreement' | 'client_portal_terms';

export type LegalAudience = 'owner' | 'member' | 'client';

export const LEGAL_CONSENT_KEYS: Record<LegalAudience, string> = {
  owner: 'consent.owner',
  member: 'consent.member',
  client: 'consent.client',
};

export const LEGAL_CONSENT_REQUIRED_KEYS: Record<LegalAudience, string> = {
  owner: 'consentRequired.owner',
  member: 'consentRequired.member',
  client: 'consentRequired.client',
};

export const LEGAL_GATE_BODY_KEYS: Record<LegalAudience, string> = {
  owner: 'gate.body.owner',
  member: 'gate.body.member',
  client: 'gate.body.client',
};

export const LEGAL_DOCUMENT_SLUGS: Record<string, LegalDocumentCode> = {
  privacy: 'privacy_notice',
  terms: 'terms_of_service',
  dpa: 'data_processing_agreement',
  'portal-terms': 'client_portal_terms',
};

export const LEGAL_DOCUMENT_PATHS: Record<LegalDocumentCode, string> = {
  privacy_notice: '/legal/privacy',
  terms_of_service: '/legal/terms',
  data_processing_agreement: '/legal/dpa',
  client_portal_terms: '/legal/portal-terms',
};
